import React from 'react';
import { useState, useEffect } from 'react';
import { CloudTables } from '@cloudtables/react';

function SearchPage() {

    let TblID = '';
    let TblIDEmail = '';

    let Season = 'SUMMER';

    if(Season === 'FALL') {
      TblID = '7a0cf73c-9b5f-11ee-b957-eff473c55a31';
      TblIDEmail = '373e86d8-9b86-11ee-966d-53564b4a9738';
    }else {
      TblID = '5838d6e4-9b5f-11ee-b957-93788dc544df';
      TblIDEmail = '48648836-9b86-11ee-966d-b3120495c9ea';
    }    

    const tbl_url = "https://pe5lg5it79.cloudtables.io/loader/" + TblIDEmail + "/table/bs5"

    useEffect(() => {

        const ctReadyHandler = function (e) {
            let datasetId = e.datasetId;
            let domId = e.domId;
            let editor = e.editor;
            let table = e.table;

            // on table click
            table.on('click', 'tbody td:not(.child, .ct-column__color), dl dt', function (e) {

                table.rows().deselect();
                table.row(this).select();
                editor.inline(this);
            });
        }

        document.addEventListener('ct-ready', ctReadyHandler);

        return () => {
            document.removeEventListener('ct-ready', ctReadyHandler);
        }

    }, []);

    return (
        <div className="searchPage">
            <CloudTables
                src={tbl_url}
                apiKey="hxGx5JMtcElhtjqre0Mly3xj"
            />
        </div>
    );
}

export default SearchPage;
